import ms from 'ms';
import { useQuery } from 'react-query';

import { detectLanguageRequest } from '../requests';

export const useLanguageDetection = (
  { type, id, attribute, text, lang },
  { staleTime = ms('1h'), enabled = true } = {},
) => {
  const {
    data = {},
    isLoading,
    isError,
  } = useQuery(
    ['translations', 'detect', type, id, attribute, text, lang],
    () => detectLanguageRequest({ type, id, attribute, text, lang }),
    { staleTime, enabled, retry: false },
  );

  return {
    ...data,
    isLoading,
    isError,
  };
};
